import { Box, Skeleton } from "@mui/material";
import "../styles/analytics.scss";

const AnalyticsSkeleton = () => {
  return (
    <Box className="analytics-skeleton-root">
      {/* Left sidebar skeletonr*/}
      <Box
        className="analytics-skeleton-sidebar"
      >
        <Box className="analytics-skeleton-sidebar-header">
          <Skeleton variant="text" width={90} height={20} animation="wave" />
          <Skeleton variant="text" width={70} height={14} animation="wave" />
        </Box>
        {Array.from({ length: 6 }).map((_, i) => (
          <Box key={i} className="analytics-skeleton-nav-item">
            <Skeleton variant="circular" width={18} height={18} animation="wave" />
            <Skeleton variant="rounded" height={16} width="70%" className="skeleton-rounded-6" animation="wave" />
          </Box>
        ))}
      </Box>

      {/* Right graph content skeleton */}
      <Box className="analytics-skeleton-content">
        <Box className="analytics-skeleton-category-header">
          <Skeleton variant="circular" width={36} height={36} animation="wave" />
          <Box className="analytics-skeleton-category-heading">
            <Skeleton variant="text" width={180} height={20} animation="wave" />
            <Skeleton variant="text" width={80} height={14} animation="wave" />
          </Box>
        </Box>
        {Array.from({ length: 2 }).map((_, i) => (
          <Box key={i} className="graph-card graph-card--fixed-height" >
            {/* Card header: title + pin button */}
            <Box className="analytics-skeleton-card-header">
              <Skeleton variant="text" width={240} height={18} animation="wave" />
              <Skeleton variant="rounded" width={110} height={28} className="skeleton-rounded-6" animation="wave" />
            </Box>

            {/* Chart body */}
            <Skeleton variant="rounded" width="100%" className="analytics-skeleton-chart-body" animation="wave" />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AnalyticsSkeleton;